import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Button } from 'core-components/library/button'
import { getHomePage } from 'core-components/sitebuilder/layout/helpers/sitePages'
import { selectRoles } from 'core-components/sitebuilder/store/selectors/selectRoles'
import { selectSitePages } from 'core-components/sitebuilder/store/selectors/selectSitePages'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

import styles from './404.module.scss'

export const Page404 = () => {
  const user = useSelector(selectUser)
  const roles = useSelector(selectRoles)
  const sitePages = useSelector(selectSitePages)
  const type = useMemo(() => {
    const mainItem = getHomePage(sitePages, user, roles)
    /** Affect to message
     * unknown type - we don't have general-menu site page for redirect to root
     */
    return mainItem ? 'default' : 'unknown'
  }, [roles, sitePages, user])
  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <div className={styles.mainTitle}>404</div>
        <div className={styles.additionalTitle}>Not found</div>
        <div className={styles.goBackButton}>
          {type === 'default' ? (
            <Button to={'/'} variant={'text'}>
              Go back to main page
            </Button>
          ) : (
            <Button variant={'text'}>Please contact system administrator</Button>
          )}
        </div>
      </div>
    </div>
  )
}
